<ion-item button (click)="openDetail.emit(item)">
  <div class="item-start" slot="start">
    <ng-content></ng-content>
    <ion-icon name="person-outline"></ion-icon>
  </div>
  <ion-label class="ion-text-wrap item-label">
    <h3 class="item-label__title">
      <span class="skeleton">{{ item.displayName }}</span>
    </h3>
    @if (showSkeleton || subheadline) {
      <p class="item-label__subheadline">
        <span class="skeleton">{{ subheadline }}</span>
      </p>
    }
  </ion-label>
</ion-item>
